import React from "react"

import {
    MDBCardImage,
    MDBCol,
    MDBRow
  } from "mdb-react-ui-kit"

import imgError from "../../assets/images/vector/404.jpg"

const NotFoundPage = () => {
    return (
        <>
            <div className="container mt-5 text-center">
                <div style={{marginTop: 100}}>
                    <MDBCardImage src={imgError} alt="Error" style={{height: 350}} />
                </div>
                <br />
                <div style={{marginTop: -30}}>
                    <h5>Maaf, halaman yang anda tuju tidak tersedia</h5>
                </div>
            </div>
        </>
    )
}

export default NotFoundPage